function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(zip),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(range),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(series);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*
@fileoverview A library of helper functions
*/

/* global Symbol */
import { flattenDeep } from 'lodash-es';
import { saveAs } from 'file-saver';
import { format } from 'd3-format';
import { select } from 'd3-selection';
var d3 = {
  format: format,
  select: select
};
import { FetchError } from './errors.js';
import patent_country_codes from '../clarivate/patent_country_codes.json';
import debug from 'debug';
import delve from 'dlv';

var dbg = function dbg(str) {
  return debug("utils:".concat(str));
};

import { parse as _parse, stringify as _stringify } from 'query-string'; // eslint-disable-line
// debug.enable('utils*');

/* ----------------------------text manipulation---------------------------- */

/**
 * Reduces one or more multiline strings to a single-line string without double
 * spaces
 * @param  {String|String[]} sth something
 * @return {String}
 * @example
 * asSingleLine(`a
 * b`)
 */

export function asSingleLine() {
  for (var _len = arguments.length, sth = new Array(_len), _key = 0; _key < _len; _key++) {
    sth[_key] = arguments[_key];
  }

  switch (sth.constructor) {
    case String:
      return sth.replace(/\s+/g, ' ');

    case Array:
      return sth.join(' ').replace(/\s+/g, ' ');

    default:
      return sth;
  }
}
/**
 * Gets an appropriate labs domain name.
 * @return {String} a labs/qa domain, depending on whether you're on staging.
 */

export function add_lux_labs_domain_name() {
  if (window.lux_labs_domain_name) return window.lux_labs_domain_name;
  var loc = window.location.host;
  if (loc.match(/(labs|dev)/)) return "//".concat(loc, "/");
  if (loc.match(/staging/)) return '//labs-qa.luxresearchinc.com/';
  if (loc.match(/member/)) return '//labs.luxresearchinc.com/';
}
export var rootUrl = add_lux_labs_domain_name();
/**
 * Get the title of a specific LMS page
 * @return {String} page title
 */

export function get_page_title() {
  if ('page_title' in window) return window.page_title;
  return document.title.split('::')[0].trim();
}
/**
 * returns a titlecased/propercased string.
 * @param  {String} str
 * @return {String} the title/propercased version of the string.
 */

export function toProperCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
/**
 * Returns a sentencecased string, like this.
 * @param  {String} text
 * @return {String}
 */

export function sentenceCaseText(text) {
  if (text.length) {
    return text[0].toUpperCase() + text.slice(1).toLowerCase();
  } else {
    return '';
  }
}
/**
 * Given an  Element, return it with its contents as a string.
 * @param  {Element} html
 * @return {String}
 */

export function decodeHtml(html) {
  // html => html.outerHTML?
  var txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}
export var parseMoney = d3.format('$.2s');
export var moneyFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0
});
/**
 * Wrap strings in quotes
 * @param  {*} datum
 * @return {*}
 */

var escapeStr = function escapeStr(datum) {
  return (datum || false).constructor === String ? "\"".concat(datum, "\"") : datum;
};
/**
 * Format an array of objects as a CSV style string
 * @param  {Object[]}  [rows=[]] List of objects to be converted to rows in a csv file
 * @param  {...String} keys   optional list of keys to use as columns
 * @return {String}           CSV formatted string
 */


export var formatCsv = function formatCsv() {
  var _ref;

  var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  for (var _len2 = arguments.length, keys = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    keys[_key2 - 1] = arguments[_key2];
  }

  keys = (_ref = []).concat.apply(_ref, _toConsumableArray(keys));
  if (!keys.length) keys = Object.keys(rows[0] || {});
  return [keys.map(escapeStr).join(',')].concat(_toConsumableArray(rows.map(function (row) {
    return keys.map(function (key) {
      return escapeStr(row[key]);
    }).join(',');
  }))).join('\n');
};
/* --------------------------file and data export---------------------------- */

/**
 * Return a filename with a file extension
 * @param  {String} filename with/out a file extension
 * @param  {String} ext  the target filetype with/out a period
 * @return {String} an appropriate filename.
 */

export function filename(filename, ext) {
  ext = ext.replace('.', ''); // manually-added file extensions are only needed on ms products

  if (!filename.match(new RegExp("\\.".concat(ext, "$")))) {
    filename = [].concat(_toConsumableArray(filename.split('.').filter(function (f) {
      return f;
    })), [ext]).join('.');
  }

  return filename;
}
/**
 * attach an event listener to a button to export a csv file
 * @param  {String} button_name html tag specific to a button
 * @param  {*}      data        csv data
 * @param  {String} filename    csv filename
 */

export function export_data_to_csv(button_name, data, filename) {
  // Set-up the export button
  d3.select(button_name).on('click', function () {
    var csv_data = {
      'json_data': data
    };
    fetch(add_lux_labs_domain_name() + 'export_csv', {
      method: 'POST',
      body: JSON.stringify(csv_data),
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(function (response) {
      return response.blob();
    }).then(function (response) {
      var blob = new Blob([response], {
        type: 'text/csv;charset=utf-8'
      });
      saveAs(blob, filename);
    }).catch(console.error); // eslint-disable-line
  });
}
/**
 * attach an event listener to a button to export a csv file
 * @param  {String} button_name html tag specific to a button
 * @param  {*}      data        csv data
 * @param  {String} filename    csv filename
 */

export function add_click_to_dl_csv(button_name, data, filename) {
  // Set-up the export button
  d3.select(button_name).on('click', function () {
    download(data, filename, 'text/csv');
  });
}
/**
 * download data
 * @param  {*}      content     Content to be downloaded
 * @param  {String} filename
 * @param  {String} contentType
 */

export function download(content, filename, contentType) {
  dbg('download')(content, filename, contentType);
  record_event("".concat(window.location.pathname).concat(window.location.search), "export ".concat(contentType || filename.split('.')[1] || 'csv'));
  if (!contentType) contentType = 'application/octet-stream';
  var blob = new Blob([content], {
    'type': contentType
  });
  saveAs(blob, filename);
}
/**
 * Convert an image to a data url
 * @async
 * @param  {String}   url url of original image
 * @return {Promise}     Promise that resolves to a data url
 */

export function getImageAsDataUrl(_x) {
  return _getImageAsDataUrl.apply(this, arguments);
} // function add_export_buttons(
// desc, searchTerm, fileNameTemplate, svg, csvData, width, height) {
//   const rightSide = $(`#${desc}-right`);
//   const cleanFilename = searchTerm.replace(/\W/g, '_')
//   .replace(/_+/g, '_').substring(0, 50);
//   const filename = desc + fileNameTemplate + '-' + cleanFilename;
//
//   rightSide.append(
//     `<input type='submit' id='${desc}-png'
//     class='btn btn-primary export-buttons png' value='Export to PNG'>`);
//   export_svg_to_png(`#${desc}-png`, svg, width, height, filename + '.png');
//
//   rightSide.append(
//     `<input type='submit' id='${desc}-csv'
//     class='btn btn-primary export-buttons csv' value='Export to CSV'>`);
//   add_click_to_dl_csv(`#${desc}-csv`, csvData, filename + '.csv');
// }

function _getImageAsDataUrl() {
  _getImageAsDataUrl = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url) {
    var img, canvas, result;
    return regeneratorRuntime.wrap(function _callee2$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            img = new Image();
            img.crossOrigin = 'anonymous';
            canvas = document.createElement('canvas');
            result = new Promise(function (resolve) {
              img.onload = function () {
                var width = img.width,
                    height = img.height;
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);
                var dataUrl = canvas.toDataURL('image/png');
                resolve({
                  dataUrl: dataUrl,
                  width: width,
                  height: height
                });
              };
            });
            img.src = "".concat(url, "?").concat(new Date().getTime());
            return _context5.abrupt("return", result);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee2);
  }));
  return _getImageAsDataUrl.apply(this, arguments);
}

export function record_event(path, desc) {
  fetch(add_lux_labs_domain_name() + 'api/record_event?' + stringifyQs({
    path: path,
    desc: desc
  }));
}
/* ------------------------------- generators ------------------------------- */

export function sum() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return flattenDeep(args).reduce(function (sum, added) {
    return sum + added;
  }, 0);
}
/**
 * A port of python's zip function. @see {@link https://stackoverflow.com/questions/4856717/javascript-equivalent-of-pythons-zip-function}
 * @param  {Iterable[]} args
 * @yield {Array} The corresponding elements of each of the arguments.
 */

export function zip() {
  var _len4,
      toZip,
      _key4,
      iterators,
      bundle,
      _args = arguments;

  return regeneratorRuntime.wrap(function zip$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          for (_len4 = _args.length, toZip = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            toZip[_key4] = _args[_key4];
          }

          iterators = toZip.map(function (arg) {
            return arg[Symbol.iterator]();
          });

        case 2:
          if (!true) {
            _context.next = 10;
            break;
          }

          bundle = iterators.map(function (iterator) {
            return iterator.next();
          });

          if (!bundle.some(function (item) {
            return item.done;
          })) {
            _context.next = 6;
            break;
          }

          return _context.abrupt("return");

        case 6:
          _context.next = 8;
          return bundle.map(function (item) {
            return item.value;
          });

        case 8:
          _context.next = 2;
          break;

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
/**
 * Mimicing python's range(), returns a generator yielding values from..to.
 * @param  {Number}    [from=0]  [description]
 * @param  {Number}    [to=0]    [description]
 * @param  {[type]}    [step=1}] [description]
 * @yield {Number}
 * @example
 * [...range({to: 3})].every((el, index) => e == [0, 1, 2][index]);
 * [...range({from: 1, to: 3})].every((el, index) => e == [1, 2][index]);
 */

export function range(_ref2) {
  var _ref2$from, from, _ref2$to, to, _ref2$step, step;

  return regeneratorRuntime.wrap(function range$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _ref2$from = _ref2.from, from = _ref2$from === void 0 ? 0 : _ref2$from, _ref2$to = _ref2.to, to = _ref2$to === void 0 ? 0 : _ref2$to, _ref2$step = _ref2.step, step = _ref2$step === void 0 ? 1 : _ref2$step;

        case 1:
          if (!(from < to)) {
            _context2.next = 7;
            break;
          }

          _context2.next = 4;
          return from;

        case 4:
          from += step;
          _context2.next = 1;
          break;

        case 7:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
/**
 * Yields an unending series of numbers.
 * @param  {Number} [from=0] The first number to be yielded
 * @param  {Number} [step=1] the step by which to increment the counter
 * @yield  {Number} the incremented counter
 */

export function series() {
  var _ref3,
      _ref3$from,
      from,
      _ref3$step,
      step,
      _args3 = arguments;

  return regeneratorRuntime.wrap(function series$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _ref3 = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, _ref3$from = _ref3.from, from = _ref3$from === void 0 ? 0 : _ref3$from, _ref3$step = _ref3.step, step = _ref3$step === void 0 ? 1 : _ref3$step;
          _context3.next = 3;
          return from;

        case 3:
          if (!true) {
            _context3.next = 8;
            break;
          }

          _context3.next = 6;
          return from += step;

        case 6:
          _context3.next = 3;
          break;

        case 8:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
/* ----------------------------array manipulation---------------------------- */

/**
 * Given an array of {year, [country code]: #patents}, move all but a given
 * number of top countries into 'Other'.
 * @param  {Object[]} list_of_dicts {[country code]: #patents}
 * @param  {Number} [num_keys=5] number of countries to keep
 * @return {Object[]} {year, [country name]: #patents, other: #patents}
 */

export function shortenListOfDictKeys(list_of_dicts) {
  var num_keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  // list countries abbreviations as full name
  var results = list_of_dicts.map(function (dict) {
    return Object.entries(dict).map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          key = _ref5[0],
          value = _ref5[1];

      if (key === 'year') return {
        year: value
      };
      /* else */

      return _defineProperty({}, patent_country_codes[key], value);
    }).filter(function (obj) {
      return obj;
    }).reduce(function (acc, red) {
      return Object.assign(acc, red);
    }, {});
  }); // [{[long country] : count}]
  // Get counts of all of the key values in a dictionary

  var top_items = {};
  results.forEach(function (obj) {
    return Object.entries(obj).filter(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 1),
          key = _ref8[0];

      return key !== 'year';
    }).forEach(function (_ref9) {
      var _ref10 = _slicedToArray(_ref9, 2),
          key = _ref10[0],
          value = _ref10[1];

      return key in top_items ? top_items[key] += value : top_items[key] = value;
    });
  }); // Get list of the top #num_keys keys

  var allowed = new Set(Object.entries(top_items).sort(function (arr0, arr1) {
    return arr1[1] - arr0[1];
  }) // max -> min sort
  .map(function (_ref11) {
    var _ref12 = _slicedToArray(_ref11, 1),
        key = _ref12[0];

    return key;
  }).slice(0, num_keys));
  allowed.add('year').add('Other'); // Restructure each result to sum up items not in topKeysList into "Other"

  results = results.map(function (dict) {
    Object.keys(dict).forEach(function (key) {
      dict.Other = dict.Other || 0;

      if (!allowed.has(key)) {
        dict.Other += dict[key];
        delete dict[key];
      }

      ;
    });
    return dict;
  });
  return results;
}
/* -------------------------Objectlike manipulation-------------------------- */

/**
 * Get the most-nested `data.data.data...data` from anything (even unefined)/
 * @param  {Any} obj something.
 * @return {Any} either what you put in or the most-nested `data` prop it has.
 */

export var deData = function deData(obj) {
  var result = 'data' in _objectSpread({}, obj) ? deData(_objectSpread({}, obj).data) : obj;
  return result;
};
export function resolve(obj) {
  for (var _len5 = arguments.length, paths = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    paths[_key5 - 1] = arguments[_key5];
  }

  for (var _i2 = 0, _paths = paths; _i2 < _paths.length; _i2++) {
    var path = _paths[_i2];
    var result = delve(obj, path);
    if (result !== undefined) return result;
  }
}
/* ------------------------- function manipulation ------------------------- */

/**
 * Syntactic sugar: wraps a charting function accepting (container, data,
 * metadata, config) so that it can be called as plotThisChart(data, metadata,
 * config).in(container)
 * @param       {[type]} chartFunction [description]
 * @return      {Object}
 */

export function _plot(chartFunction) {
  return function () {
    for (var _len6 = arguments.length, params = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      params[_key6] = arguments[_key6];
    }

    return {
      in: function _in(container) {
        return chartFunction.apply(void 0, [container].concat(params));
      }
    };
  };
}
export function cachedStrFn(fn) {
  var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function cachedFn(str) {
    var hit = cache[str];
    return hit === undefined ? hit : cache[str] = fn(str);
  };
}
/* ----------------------------- browser utils ----------------------------- */

/**
 * detect IE/Edge
 * @see https://codepen.io/gapcode/pen/vEJNZN
 * returns version of IE or false, if browser is not Internet Explorer
 * @param {String?} ua user-agent ident
 * @returns {Boolean|Number}
 */

export function detectIE(ua) {
  ua = ua || window.navigator.userAgent; // Test values; Uncomment to check result …
  // IE 10
  // 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
  // IE 11
  // 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
  // Edge 12 (Spartan)
  // 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36
  // (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
  // Edge 13
  // 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36
  // (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  var msie = ua.indexOf('MSIE ');

  if (msie > 0) {
    // IE 10 or older
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');

  if (trident > 0) {
    // IE 11
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');

  if (edge > 0) {
    // Edge (IE 12+)
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  } // other browser


  return false;
}
/**
 * encode bracket-encoded url querystrings
 * @param  {Object} obj object to be stringified
 * @return {String}
 */

export var stringifyQs = function stringifyQs(obj) {
  Object.keys(obj).forEach(function (k) {
    // non-breaking space characters were causing some apis to fail
    if (obj[k] && obj[k].constructor === String) obj[k] = obj[k].replace(/\xa0/g, ' ');
  });
  return _stringify(obj, {
    arrayFormat: 'bracket'
  });
};
export var parseQs = function parseQs(obj) {
  return _parse(obj, {
    arrayFormat: 'bracket'
  });
};
/**
 * inform jquery of the state of fetches
 * @param  {Function} cb a fetch function (async by nature)
 * @return {Function} a function that updates jquery's active-fetch counter
 */

export var wrapFetch = function wrapFetch(cb) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var result,
        _args4 = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (window.$) window.$.active += 1;
            _context4.next = 3;
            return cb.apply(void 0, _args4).catch(console.error);

          case 3:
            result = _context4.sent;
            // eslint-disable-line
            if (window.$) window.$.active -= 1;
            return _context4.abrupt("return", result);

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee);
  }));
};
/**
 * Check JSON API request succeeded
 * @async
 * @function
 * @param  {Response} response
 * @param  {String|FetchError~messageCallback} [message=''] a custom message
 * or message formatter
 * @return {Object|Array|String|Number|null} the JSON response
 * @throws {FetchError} iff the request failed
 */

export function checkResponse(_x2) {
  return _checkResponse.apply(this, arguments);
}
/* -------------------------------api-specific------------------------------- */

/**
 * Find sum of patents for all entries in data array
 * @param  {Object[]} data List of objects containing patent data
 * @return {Number}        Sum of published patents
 */

function _checkResponse() {
  _checkResponse = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(response) {
    var message,
        data,
        _args6 = arguments;
    return regeneratorRuntime.wrap(function _callee3$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            message = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : '';
            _context6.next = 3;
            return response.text();

          case 3:
            data = _context6.sent;

            try {
              data = JSON.parse(data);
            } catch (err) {
              /* do nothing*/
            }

            if (response.ok) {
              _context6.next = 7;
              break;
            }

            throw new FetchError({
              response: response,
              data: data,
              message: message
            });

          case 7:
            return _context6.abrupt("return", data);

          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee3);
  }));
  return _checkResponse.apply(this, arguments);
}

export function calcPatentsPublished(data) {
  return data.reduce(function (t, e) {
    return t + e['published'];
  }, 0);
}